module.exports = function getResource(label, vars=[]) {
    return {
        add: 'Add',
        viewAll: 'View All',
        signInToAccess: 'Sign In to Access',
        notSignedIn: 'Sign in to redeem your points.',
        notEnoughPoints: 'You have',
        keepEarning: 'Keep earning to redeem rewards!',
        redeemPoints: 'Redeem your',
        points: 'points'
    }[label];
};
